export default __webpack_public_path__ + "static/media/ic_reports.71258e22.svg";